<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZA6VHH/tc-custom/9781504067348.jpg?1716663162736" alt="This image is the cover for the book Bridemaker, The Matchmaker Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bridemaker, The Matchmaker Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A devilish rake will do anything to learn the secret of a straitlaced schoolmarm in this Regency romance by the bestselling author of <i>The Troublemaker</i>.</b><br/><br/> Word has it that every awkward young lady sent to Mrs. Hester Poitevant’s Mayfair Academy inevitably becomes marriage material. With her students going on to have any eligible bachelor they wish, Hester is able to live comfortably and in the background. And no one knows that under the guise of a stuffy widow, she is a beautiful woman who has never been married.<br/><br/> Although Adrian Hawke is a dashing and successful businessman, his scandalous birth makes him a less-than-ideal candidate for a husband. When he draws attention from one of Hester’s favorite students, the prim Mrs. Poitevant forcefully puts a stop to it—and falls victim to his charms herself. Adrian, meanwhile, is not fooled by the feisty widow’s facade. Intrigued, the clever rogue is determined to uncover what Hester is hiding in more ways . . . than one.<br/><br/> Perfect for fans of the Bridgerton series!<br/><br/> “With this sparkling romance between a highly regarded widow and a thoroughly charming rake, Becnel . . . breathes life into the rigid Regency-era romance genre. . . . Hester’s spirited personality and Adrian's devil-may-care attitude will appeal to a broad readership. Playful in tone and rich in character, this book is fun, breezy entertainment.” —<i>Publishers Weekly</i><br/><br/> “A real treat.” —<i>Booklist</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rexanne Becnel
      </h2>
      
      <p class="authorDescription body article">Rexanne Becnel is the author of more than twenty historical romance and contemporary mainstream novels, many of which appeared on the <i>USA Today</i> bestseller list. With the publication of her first novel, <i>My Gallant Enemy</i>, Becnel won the Waldenbooks Award for Best First-Time Romance Author and the Romantic Times Award for Best Medieval Romance by a New Author. While growing up, Becnel lived for a time in Germany and England, where she became fascinated by medieval history. After studying architecture at the University of Southwestern Louisiana, she worked as a building inspector for the Vieux Carr&eacute; Commission, the agency of the City of New Orleans charged with protecting and preserving the distinct architectural and historic character of the French Quarter. Becnel lives in New Orleans with her husband and two children. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7217f0ac